<div id="navigation-drawer-mobile" *ngIf="isMenuVisible">
    <mat-divider></mat-divider>
    <div><a [routerLink]="['/']" (click)="hide()">HOME</a></div>
    <mat-divider></mat-divider>
    <div><a [routerLink]="['/faq']" (click)="hide()">FAQ</a></div>
</div>
